import template from './paged.teleconsent-share.html';
import pagedDocument from '../../../paged-document/document.paged-document.js';
import AuditTrialService from './audit-trial-service';
import {
  hasGrowthBookFeature,
  GrowthBookFeatures,
} from '../../../../../../../modules/core';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.share.paged.teleconsent-share',
    [pagedDocument, AuditTrialService]
  )
  .component('pagedTeleconsentShare', {
    //paged-teleconsent-share
    template,
    bindings: {
      document: '<',
      me: '<',
      innerMediator: '<',
    },
    controller: function (
      $scope,
      tcDataParser,
      notificationFactory,
      AuditTrailService,
      Document,
      $timeout
    ) {
      this.$onInit = () => {
        // Ensure document and metadata are available before accessing them
        if (!this.document || !this.document.metadata) {
          console.warn('TeleconsentShare: document or metadata not available');
          return;
        }

        this.document.data = tcDataParser.parseFields(
          this.document.metadata.fields || {}
        );
        this.document.pages = this.document.metadata.pages;
        this.document.fields = this.document.metadata.fields;
        
        const auditTrialService = new AuditTrailService({
          document: this.document,
          me: this.me,
          innerMediator: this.innerMediator,
        });

        $scope.$watch(
          '$ctrl.document.data',
          auditTrialService.watch.bind(auditTrialService),
          true
        );

        // Ensure innerMediator is available before calling on
        if (this.innerMediator && typeof this.innerMediator.on === 'function') {
          this.innerMediator.on('submit:get', (res) => {
            this.markSubmit(res.isValid);
          });
        } else {
          console.warn('TeleconsentShare: innerMediator not available or missing on method');
        }

        // Set finalizePages on document after ensuring document is available
        this.document.finalizePages = this.finalizePages.bind(this);
      };

      this.markSubmit = function (isValid) {
        if (!this.form) return;
        this.form.$setSubmitted();
        if (!isValid) {
          notificationFactory.showCommon('error', 'teleconsent-submit-error');
          $scope.$broadcast('submit:error');
        }
      };

      this.cancel = () => {
        this.innerMediator.emit('cancel');
      };

      this.finalizePages = function () {
        this.innerMediator.emit('submit', {
          isValid: this.form.$valid,
        });
        this.markSubmit(this.form.$valid);
        if (this.form.$invalid) return;

        return (this.finalizePromise =
          Document.prototype$finalizePagesTeleconsent({
            id: this.document.documentId,
            html: document.querySelector('#document-pages').innerHTML,
          }).$promise.then((res) => {
            $timeout(() => {
              this.document.isFinal = true;
              this.innerMediator.emit('final', {
                data: res,
                documentType: this.document.type,
                documentName: this.document.name,
                isDefault: this.document.isDefault,
              });
            }, 1000);
          }));
      };
    },
  }).name;
